const isServer = process.env.NEXT_RUNTIME === 'nodejs';

const formatDate = (date: Date) => {
  const pad = (n: number) => n.toString().padStart(2, '0');

  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

const parseErrorOrMessage = (errorOrMessage: any) => {
  if (typeof errorOrMessage === 'string') {
    return errorOrMessage;
  }

  if (typeof errorOrMessage === 'object' && errorOrMessage !== null) {
    try {
      // NOTE : 타입상 JSON.stringify() 에서 에러 발생 가능성이 있음
      return JSON.stringify(errorOrMessage, Object.getOwnPropertyNames(errorOrMessage));
    } catch {
      return String(errorOrMessage);
    }
  }

  return String(errorOrMessage);
};

type LogLevel = 'DEBUG' | 'INFO' | 'WARN' | 'ERROR';

const stdoutLogger = (errorOrMessage: any, logLevel: LogLevel) => {
  if (!isServer) return;
  console.log(`${formatDate(new Date())} | ${logLevel} | ${parseErrorOrMessage(errorOrMessage)}`);
};
const stderrLogger = (errorOrMessage: any, logLevel: LogLevel) => {
  if (!isServer) return;
  console.error(`${formatDate(new Date())} | ${logLevel} | ${parseErrorOrMessage(errorOrMessage)}`);
};

const logger = {
  debug: (error: any) => stdoutLogger(error, 'DEBUG'),
  info: (error: any) => stdoutLogger(error, 'INFO'),
  warn: (error: any) => stdoutLogger(error, 'WARN'),
  error: (error: any) => stderrLogger(error, 'ERROR'),
};

export { logger };
